<template>
  <div class="header">
        <div class="headerTitle">
          <img src="../assets/img/car.png" class="logo" @click="collapseChage">
          <p class="Title">China-PCS系统</p>
        </div>
        <div class="headerMenu" >
          <div class="list" >
            <el-tooltip effect="dark" content="查看系统使用说明书" placement="top">
              <img src="../assets/img/question.png" class="systemBook" @click="systemBook"/>
            </el-tooltip>
            <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="top">
              <img src="../assets/img/fullScreen.png" class="menuLogo" @click="handleFullScreen" v-if="downIcon"/>
              <img src="../assets/img/outFullScreen.png" class="menuLogo" @click="handleFullScreen" v-if="!downIcon"/>
            </el-tooltip>
          </div>

          <div class="gotoMain" @click="go">
            <img src="../assets/img/index.png" class="index">
            返回主页
          </div>

          <div class="user" v-for="item in  user">
            <!-- 用户名下拉菜单 -->
            <el-dropdown class="user-name" trigger="click">
                    <span class="el-dropdown-link">
                        {{item.userName}} <i class="el-icon-caret-bottom"></i>
                    </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="self" style="width: 150px;text-align: center">账户信息</el-dropdown-item>
                <el-dropdown-item @click.native="goBack" style="width: 150px;text-align: center">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
  </div>
</template>

<script>
  import bus from  './bus'

  export default {
    name: "header",
    data() {
      return {
        collapse: false,
        fullscreen: false,
          downIcon: true,
        user: [
          {
            "userName": JSON.parse(localStorage.token)
          }
        ]
      }
    },
    methods: {
      // 全屏事件
      handleFullScreen() {
        let element = document.documentElement;
        if (this.fullscreen) {
            this.downIcon = !this.downIcon;
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if (element.requestFullscreen) {
              this.downIcon = !this.downIcon;
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen = !this.fullscreen;
      },
      /*查看个人信息*/
      self() {
       bus.$emit('personIfo','')
      },
      /*返回主页*/
      go() {
        this.$router.push('/system/index');
      },
      /*退出系统*/
      goBack() {
        localStorage.clear();
        this.$router.push('/')
      },
       /*侧边栏折叠*/
      collapseChage() {
        this.collapse = !this.collapse;
        bus.$emit('collapse', this.collapse);
        bus.$emit('color');
      },
      systemBook(){
        window.open('http://resource.xhrtas.com/rtas/20191128/1574925265005_507.pdf','_blank');
      }
    },
  }
</script>

<style scoped>
  /*头部导航栏*/
  *{
    padding: 0;
    margin: 0;
  }
  .header{
    min-height: 42px;
    min-width: 1097px;
    height: 100%;
    width: 100%;
    background-color: cadetblue;
    display: flex;
  }
  .headerTitle{
    width: 30%;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 1.5em;
    font-family: 微软雅黑;
    letter-spacing: 3px;
    color: white;
  }
  .logo{
    width: 40px;
    cursor: pointer;
    margin-left: 20px;
  }
  .Title{
    margin-left: 20px;
  }
  .headerMenu{
    width: 70%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .list{
    width: 3%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .menuLogo{
    width: 20px;
    cursor: pointer;
  }
  .gotoMain{
    width: 12%;
    min-width: 120px;
    min-height: 42px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 1.1em;
    cursor: pointer;
  }
  .index{
    width: 20px;
  }
  .user{
    height: 100%;
    min-width: 152px;
    min-height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.1em;
    color: white;
  }
  /*下拉菜单样式*/
  .user-name{
    cursor: pointer;
    color: white;
    font-size: 1em;
  }
  .systemBook{
    width: 20px;
    cursor: pointer;
    margin-right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue